export default __webpack_public_path__ + "static/media/notification-9.1ea69b0b.mp3";